<template>
  <v-container>
    <h1>更新維修單資料</h1>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="data.clientName"
            :counter="10"
            :rules="[v => !!v || '名字必須填寫']"
            label="客戶名字"
            required
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-text-field
            v-model="data.address"
            :counter="10"
            :rules="[v => !!v || '戶別必須填寫']"
            label="戶別"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="data.phone"
            :rules="[v => !!v || '電話必須填寫']"
            label="電話"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-select
            v-model="data.site"
            :items="sites"
            :rules="[v => !!v || '建案必須填寫']"
            label="建案"
            required
          ></v-select>
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="data.problemType"
            :items="problemTypes"
            :rules="[v => !!v || '問題類別必須填寫']"
            label="問題類別"
            required
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-textarea
            v-model="data.description"
            label="描述"
            value=""
            :rules="[v => !!v || '描述必須填寫']"
            hint="請描述你的問題"
          ></v-textarea>
        </v-col>
      </v-row>

      <v-btn
        color="blue-grey lighten-1"
        outlined
        class="mr-4"
        @click="$router.go(-1)"
      >
        取消
      </v-btn>

      <v-btn color="blue-grey white--text " @click="submitForm">
        送出
      </v-btn>
    </v-form>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { repairsCollection } from "@/db";

export default {
  name: "Edit",
  data: () => ({
    valid: true,
    sites: [
      "耀嵩豐",
      "悅嵩豐",
      "松丰",
      "文川",
      "淨美墅",
      "世璽",
      "帝門",
      "自由鑫貴",
      "綠園市2",
      "綠園市1",
      "品美術",
      "觀美術",
      "大社官邸",
      "嵩豐臻寶",
      "狀元邸",
      "嵩之園",
      "千禧園",
      "三荷園",
      "東方伯爵"
    ],
    problemTypes: [
      "水電",
      "防水",
      "衛浴設備",
      "弱電",
      "磁磚",
      "廚具",
      "油漆",
      "木作",
      "其他"
    ],
    data: {
      id: "",
      site: "",
      phone: "",
      description: "",
      address: "",
      clientName: "",
      problemType: ""
    }
  }),
  created() {
    repairsCollection
      .doc(this.$route.params.repair_id)
      .get()
      .then(doc => {
        if (doc.exists) {
          this.data = {
            ...this.data,
            ...doc.data(),
            id: this.$route.params.repair_id
          };
        } else {
          // doc.data() will be undefined in this case
          // eslint-disable-next-line no-console
          console.log("No such document!");
        }
      });
  },
  methods: {
    submitForm() {
      repairsCollection
        .doc(this.$route.params.repair_id)
        .update({
          site: this.data.site,
          description: this.data.description,
          address: this.data.address,
          problemType: this.data.problemType,
          clientName: this.data.clientName,

          completed: this.data.completed
        })
        // eslint-disable-next-line no-unused-vars
        .then(docRef => {
          this.$router.push(`/show/${this.$route.params.repair_id}`);
        })
        // eslint-disable-next-line no-console
        .catch(error => console.log(error));
    }
  }
};
</script>
